import { createReducer } from "reduxsauce";
import Types from "./types";

export const INITIAL_STATE = {
    isVideoGalleryModalOpen: false
};

export const setVideoGalleryModalOpen = (state = INITIAL_STATE, { isOpen }) => {
    return {
        ...state,
        isVideoGalleryModalOpen: isOpen
    };
};

export const HANDLERS = {
    [Types.SET_VIDEO_GALLERY_MODAL_OPEN]: setVideoGalleryModalOpen
};

export default createReducer(INITIAL_STATE, HANDLERS);
